import React from "react";

import { wrapper, btn as toolbarBtn } from "./Toolbar.css";
import {
  row,
  col,
  alignItemsCenter,
  btn,
  btnLight,
  dFlex,
  mlAuto,
  ml3,
  mr2
} from "bootstrap/dist/css/bootstrap.css";
import DataService from "./DataService";

/**
 * @typedef {object} Props
 * @prop {string} brandRequestGroupName
 * @prop {string} brandRequestGroupId
 * @prop {boolean} showUploadBatchButton
 * @prop {number} toBeProcessedCount
 * @prop {() => void} onDeleteBrandRequestGroup
 * @prop {(newBrandRequestGroupName) => void} onUpdateBrandRequestGroupName
 * @prop {boolean} isUploadBatchButtonDisabled
 * @prop {boolean} isAdmin
 * @prop {boolean} hasVisualDuplicates
 *
 *
 * @extends {React.Component<Props>}
 */
class Toolbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inEditMode: false,
      isSent: false,
      newBrandRequestGroupName: ""
    };

    this.sendBatch = this.sendBatch.bind(this);
  }

  sendBatch() {
    const { isAdmin, brandRequestGroupName, brandRequestGroupId } = this.props;

    if (isAdmin === false) {
      this.setState({ isSent: true });
      DataService.sendEmail(brandRequestGroupName, brandRequestGroupId);
    }
  }

  render() {
    const {
      brandRequestGroupName,
      showUploadBatchButton = false,
      toBeProcessedCount,
      onDeleteBrandRequestGroup,
      onUpdateBrandRequestGroupName,
      isUploadBatchButtonDisabled,
      isAdmin,
      hasVisualDuplicates
    } = this.props;
    const { inEditMode, newBrandRequestGroupName, isSent } = this.state;

    return (
      <div className={`${wrapper} ${row}`}>
        <div className={`${col} ${alignItemsCenter} ${dFlex}`}>
          {!inEditMode ? (
            brandRequestGroupName
          ) : (
            <input
              type="text"
              value={newBrandRequestGroupName}
              onChange={e =>
                this.setState({ newBrandRequestGroupName: e.target.value })
              }
            />
          )}
          {!inEditMode ? (
            <React.Fragment>
              <i
                className={`fa fa-pencil ${ml3} ${mr2} ${toolbarBtn}`}
                aria-hidden="true"
                onClick={() =>
                  this.setState({
                    inEditMode: true,
                    newBrandRequestGroupName: brandRequestGroupName
                  })
                }
              />
              <i
                className={`fa fa-trash ${toolbarBtn}`}
                aria-hidden="true"
                onClick={onDeleteBrandRequestGroup}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <i
                className={`fa fa-check ${ml3} ${mr2} ${toolbarBtn}`}
                aria-hidden="true"
                onClick={() => {
                  this.setState({ inEditMode: false });
                  onUpdateBrandRequestGroupName(newBrandRequestGroupName);
                }}
              />
              <i
                className={`fa fa-times ${toolbarBtn}`}
                aria-hidden="true"
                onClick={() => this.setState({ inEditMode: false })}
              />
            </React.Fragment>
          )}

          <span className={`${mlAuto}`}>
            {hasVisualDuplicates && (
              <span className="mr-3">
                <i
                  className="fa fa-exclamation-triangle mr-1"
                  aria-hidden="true"
                ></i>
                Duplicates
              </span>
            )}
            {toBeProcessedCount} to be processed
          </span>
          {showUploadBatchButton && (
            <button
              type="submit"
              className={`${btn} ${btnLight} ${ml3}`}
              data-toggle={isAdmin ? "modal" : ""}
              data-target="#exampleModalCenter"
              disabled={isUploadBatchButtonDisabled || isSent}
              onClick={this.sendBatch}
            >
              {isAdmin
                ? "Upload batch"
                : isSent
                ? "Sent, thanks!"
                : "Send batch"}
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/Toolbar.js